import ResourcesModal from "@/components/resources_modal";
import ResourceList from "@/components/resource_list";
import ShareSvg from "@/components/svgs/share_svg.js";
import { useState, useEffect} from 'react'; 
import stringifySearch from '@/lib/utils'
import ArrowUpRightSvg from '@/components/svgs/arrow_up_right.js'
import Loader from '@/components/loading_animation.js'

const DownloadAction =  (props) => {
  const { selectedDownloads, product, errors, setErrors} = props
  const [loading, setLoading] = useState(false)
  const getIds = () => {
    return Object.values(product.downloads || {}).flat().filter((d, i) => selectedDownloads.includes(d.url)  ).map((d, i) => d.id )
  }


   const createZip = async ( ) => {
    let data = {file_ids:  getIds(), product_id: product.id}
    setLoading(true)
    let  resp = await fetch(`/lex-api/file_zip/all?${stringifySearch(data)}`, {method: 'POST' }).then(async (resp)=>       {
      if (resp.ok) {
        setLoading(false)
        let data = await resp.json()
        window.location = data.url;
      }

      else {
        setLoading(false)
        setErrors('There was a problem completing your download. Please try again later')
      }
    })
   }

  return (
    <>
      {loading ? (<Loader><p className='lexcms-wait-message'>Download is being prepared now, please hold... </p></Loader>

       ) : 
      (<div className='lexcms-download-zip-wrapper'> <a onClick={selectedDownloads.length > 0 ? createZip : () => {}  } 
        className={`lexcms-regular-button lexcms-copy-links-button ${selectedDownloads.length > 0 ? '' : 'disabled' }`}
        >
            <ShareSvg />
            <span>Download </span>
        </a>
      </div>
      ) 
      }
    </>
  )
}

export default function ShareDownloadsModal({product, setShowShare, showShare, type}) {
  const [buttonText, setButtonText] = useState('Copy Links')
  const [errors, setErrors] = useState('')
  const downloadsForKeyCount = (key ) => {
    return( product.downloads || {} )[key]?.length
  }

  const [selectedDownloads, setSelectedDownloads] = useState([])
  const handleChange = (download, event) => {
    if (selectedDownloads.includes(download.url)) {
      setSelectedDownloads((prev ) => prev.filter((d, i) => d !== download.url ) )
    }
    else {
     setSelectedDownloads((prev) => [...prev, download.url]  )
    }
  }

  const allSelected = () => {
   return  selectedDownloads.length === Object.values(product.downloads || {}).flat().length 
  }

  const selectAll = () => {
    if (allSelected()) {
      setSelectedDownloads(() => [] )

    }
    else {
    setSelectedDownloads((prev ) => Object.values(product.downloads || {}).flat().map((d, i) =>d.url ) )

    }
  }

  const copyToClipboard = ( ) => {
    const outputStr = selectedDownloads.join("\r\n") 
    navigator.clipboard.writeText(outputStr);
    setButtonText('Copied!')
  }

 
  const bulkAction = type === 'download' ? <DownloadAction errors={errors} setErrors={setErrors}  
                                               selectedDownloads={selectedDownloads} product={product}  />  :  (<a
            onClick={selectedDownloads.length > 0 ? copyToClipboard : () => {}  } 
            className={`lexcms-regular-button lexcms-copy-links-button ${selectedDownloads.length > 0 ? '' : 'disabled' }`}
          >
            <ShareSvg />
            <span>{buttonText }</span>
        </a>)

  const shareText =  type === 'download' ?  `Streamline your downloads! Select one or multiple assets from our resources, zip them into a single file, and download everything you need with just a few clicks.` : `Select one or more multiple resource links, copy them
          with a click, and share them instantly with your team,
          clients, or collaborators.`


  useEffect(() => {
    const timer = setTimeout(() => {
      setButtonText('Copy Links')

    }, 2000)

  }, [buttonText] )
  return (
    <ResourcesModal show={showShare} setShow={setShowShare}>
      {type === 'download' ? ( 
      <h3>
        <div className="lexcms-product-downloads-icon"></div>
        <strong>Download</strong>
       {errors && <p className='lexcms-errors'>{errors }</p>  }
      </h3>) : ( 
        <h3>
          <div className="lexcms-product-share-icon"></div>
          <strong> Share Links</strong>
        </h3>
      )
      }
      <hr className="lexcms-section-divider"></hr>
      <div   className="lexcms-product-top-share-section" >
        <p className="lexcms-product-top-share-text">
          {shareText } 
        </p>
        <div className="lexcms-product-top-share-section-actions">
          <p>
          <input type='checkbox' checked={allSelected()} onChange={(e) => selectAll( ) } />
          Select All
          </p>
          {bulkAction}
        </div>
      </div>
     {Object.keys(product.downloads || {}).map((key, i) => {
      return (
      <div 
        key={key}

         className="lexcms-product-resource-list-container">
        <div className="lexcms-product-resource-list-heading">
          <h5>{key}</h5>
          <small>({downloadsForKeyCount(key) })</small>
        </div>
        <hr className="lexcms-section-divider"></hr>
         <ResourceList >
           {product.downloads[key]?.map((download, i) => {
             return (
          <li key={i} className="lexcms-product-share-filename">
            <input type='checkbox' checked={selectedDownloads.includes(download.url)} onChange={(e) => handleChange(download, e) } />
            <a href={download.url} target="_blank">
             {download.name}
            </a>
          </li>
             )
           })
           }
        </ResourceList> 
      </div>
      )

      })
      }
    </ResourcesModal>
  )
}

